import {useDispatch} from 'react-redux';
import PropTypes from 'prop-types';
import {getRangeSpeedPipettingParameter} from 'stores/business/pipettingParameterBusiness';
import {parseMessage} from 'lib/stringHelper';
import {TaskType} from 'constants/dataEnum';
import {PipettingProfileItemWrapper} from '../PipettingProfileWrapper';
import PipettingProfileInputType from '../PipettingProfileInputType';

function PipettingItemSpeed({task, onChange}) {
  const dispatch = useDispatch();
  const {type, speed} = task;

  const rangeSpeed = dispatch(getRangeSpeedPipettingParameter(task));
  const getLabelText = () => {
    const labelAspirate = parseMessage('protocolEditor.taskList.pipettingProfile.speedAspirate', {
      volumeLimits: `${rangeSpeed?.minValue} - ${rangeSpeed?.maxValue}`,
    });
    const labelDispense = parseMessage('protocolEditor.taskList.pipettingProfile.speedDispense', {
      volumeLimits: `${rangeSpeed?.minValue} - ${rangeSpeed?.maxValue}`,
    });

    return type === TaskType.ASPIRATE ? labelAspirate : labelDispense;
  };

  return (
    <PipettingProfileItemWrapper>
      {getLabelText()}
      <PipettingProfileInputType.NumericTextBox
        value={speed}
        minValue={rangeSpeed?.minValue}
        maxValue={rangeSpeed?.maxValue}
        onChange={(value) => onChange(value, type)}
      />
      <PipettingProfileInputType.Unit.MicroLiterPerSec />
    </PipettingProfileItemWrapper>
  );
}

PipettingItemSpeed.propTypes = {
  onChange: PropTypes.func.isRequired,
  task: PropTypes.object.isRequired,
};

export default PipettingItemSpeed;
